import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { SearchTable } from "utils/Utils";
import { useSelector } from "react-redux";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import { Grid } from "@material-ui/core";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ToastModal from "views/components/ToastModal";
import { getPreviousDateAccToDays } from "utils/Utils";
import { parseDateMDY } from "utils/Utils";
import { completeTableColumns } from "assets/properties/properties";
import { removeUnderscores } from "utils/Utils";
import { useNavigate } from "react-router-dom";
import CopyableText from "components/Common/CopyableText";
import * as XLSX from "xlsx";
import { particularDesignationAccess } from "assets/properties/properties";
import { formatAmount } from "utils/Utils";
import { getApplicationFromDate } from "assets/properties/properties";
import useApplicantStatusData from "hooks/useApplicantStatusData";
import { parseAndSetFlag } from "utils/Utils";
import ViewDetailsLink from "./SendBackDetails/ViewDetailsLink";
import StageHistoryModal from "./SendBackDetails/StageHistoryModal";
const Completed = ({seletedBranchCode, featureFlags}) => {
  const navigate = useNavigate();
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastMessageType, setToastMessageType] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [rawData, setRawData] = useState([]);
  const [showLinkedLoanBranchFlag, setShowLinkedLoanBranchFlag] =
    useState(false);
  const [enabledInsurance, setEnabledInsurance] = useState(false);
  const [fromDate, setFromDate] = useState(getApplicationFromDate());
  const [toDate, setToDate] = useState(new Date());
  const [userDetails, setUserDetails] = useState({});
  const [stageHistoryModal, setStageHistoryModal] = useState(false);
  const [selectedLeadId, setSelectedLeadId] = useState(null);
    const enabledSendBackStageDetails = parseAndSetFlag(
    featureFlags?.enabledSendBackStageDetails
  );
  const handleFromDateChange = (e) => {
    setFromDate(e);
  };
  const handleToDateChange = (e) => {
    setToDate(e);
  };

  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
    setToast(showToast);
  };
  const {
    data: applicantData,
    error: applicantDataError,
    callInProgress: applicantDataLoading,
    refetch: refetchApplicantData,
  } = useApplicantStatusData({
    status: "COMPLETED",
    fromDate,
    toDate,
    authToken,
    featureFlags,
  });
  useEffect(() => {
    GetUserDetails();
  }, []);
  const GetUserDetails = async () => {
      const result = await apiHandler({
        url: endpoint.USER_DETAIL,
        authToken: authToken,
      });
      console.log(result?.data,"fsdjhfsjhdf")
      setUserDetails(result?.data);
  };


  useEffect(() => {
    if (!featureFlags) return;

    parseFlags(
      featureFlags?.showLinkedLoanBranchFlag,
      setShowLinkedLoanBranchFlag
    );
  }, [featureFlags]);

  const parseFlags = (flag, setStateFunction) => {
    const parsedFlag = typeof flag === "boolean" ? flag : flag === "true";
    setStateFunction(parsedFlag);
  };
  const [tableColumns, setTableColumns] = useState(completeTableColumns);
  const tableHeader = enabledSendBackStageDetails
    ? [
        ...tableColumns,
        { id: "stageHistory", label: "Stage History", show:true },
      ]
    : tableColumns;
  useEffect(() => {
    setTableColumns((prevList) =>
      prevList.map((item) => {
        switch (item.id) {
          case "linkedBranch":
            return { ...item, show: showLinkedLoanBranchFlag };
          default:
            return item;
        }
      })
    );
  }, [showLinkedLoanBranchFlag]);

  const visibleDeliverables = tableHeader.filter((item) => item.show);

  useEffect(() => {
    if (applicantDataError) {
      toastUpdate("Error", applicantDataError.user_description, true);
    } else {
      parseIndicatorData(applicantData);
      setRawData(applicantData);
    }
  }, [applicantData, applicantDataError]);

  const parseIndicatorData = (data) => {
    let reportData = [];
    data = data.sort((a, b) =>
      a.loanApplicationId < b.loanApplicationId ? 1 : -1
    );
    data &&
      data.forEach((CompletedApplication, index) => {
        let row = {
          applicationid: CompletedApplication.loanApplicationId,
          created: CompletedApplication.createdBy,
          formNumber: CompletedApplication.loanApplicationNumber,
          accountNumber: CompletedApplication.loanAccountNumber,
          accountNumberDisplay: (
            <CopyableText
              text={CompletedApplication.loanAccountNumber}
              onCopy={() =>
                toastUpdate("Success", "Account Number Copied", true)
              }
            />
          ),
          linkedBranch: CompletedApplication.linkedLoanBranchName,
          customerid: CompletedApplication.customerId,
          customerName: CompletedApplication.customerName,
          branchCode: CompletedApplication.branchCode,
          disbursalAmount: formatAmount(CompletedApplication?.disbursalAmount),
          disbursalDate: parseDateMDY(CompletedApplication?.disbursalDate),
          type: `${removeUnderscores(
            CompletedApplication?.applicationType
          )} / ${removeUnderscores(CompletedApplication?.applicationSubType)}`,
          totalCollateralValue: CompletedApplication?.totalCollateralValue,
          disbursalLoanAmount: CompletedApplication?.disbursalAmount,
          productType: CompletedApplication?.productType,
          ...(enabledSendBackStageDetails
        ? {
            stageHistory: (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "8px",
                }}
              >
                {Number(
                  CompletedApplication?.applicationStageHistoryCount
                ) > 0 && (
                  <ViewDetailsLink
                    onClick={() => {
                      setSelectedLeadId(
                        CompletedApplication?.loanApplicationId
                      );
                      setStageHistoryModal(true);
                    }}
                  />
                )}
              </div>
            ),
          }
        : {}),
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  const onSearchChange = (event) => {
    const filteredData = SearchTable(
      rawData,
      ["loanAccountNumber", "customerName", "customerId", "loanApplicationNumber", "mobileNumber"],
      event?.target?.value
    );
    parseIndicatorData(filteredData);
  };
  const onClickUpdateData = async (
    loanApplicationId,
    customerProcessId,
    loanAccNumber,
    totalCollateralValue,
    disbursalAmount,
    productType,
  ) => {
    const result = await apiHandler({
      url: endpoint.LOAN_STATUS + `?loanApplicationId=${loanApplicationId}`,
      authToken: authToken,
    });
    const prepledgeLoanMap = result?.data?.prepledgeLoanMap || [];
    const prepledgeLoanAccountNumber = result?.data?.prepledgeLoanAccountNumber ? result?.data?.prepledgeLoanAccountNumber : Object.keys(prepledgeLoanMap || {})?.[0]
    getInsuranceData(loanApplicationId);
    const navigationData = {
      loanApplicationId: loanApplicationId,
      status: "COMPLETED",
      subStatus: result?.data?.applicationSubType,
      editable: false,
      prePledgeLoan: prepledgeLoanAccountNumber,
      customerProceedId: customerProcessId,
      loanAccountNumber: loanAccNumber,
      loanType: result?.data?.applicationType,
      enabledInsurance: enabledInsurance,
      totalCollateralValue: totalCollateralValue,
      seletedBranchCode: seletedBranchCode,
      prepledgeLoanMap:prepledgeLoanMap,
      disbursalAmount,
      productType,
    };
    navigate(`/fieldAgent/${loanApplicationId}`, { state: navigationData });
  };
  const getInsuranceData = async (loanApplicationId) => {
    const result = await apiHandler({
      url: endpoint.GET_INSURANCE_PREMIUM + loanApplicationId,
      method: "GET",
      authToken: authToken,
    });
    setEnabledInsurance(Number(result?.data?.totalPremium) > 0);
  };
  const button1Click = () => {
  const sortedData = [...rawData].sort(
    (a, b) => new Date(b.disbursalDate || 0) - new Date(a.disbursalDate || 0)
  );

  const excelData = sortedData.map((item) => ({
    "Application ID": item.loanApplicationId,
    "Application Number": item.loanApplicationNumber,
    "Loan Account Number": item.loanAccountNumber,
    "Customer ID": item.customerId,
    "Customer Name": item.customerName,
    "Branch Code": item.branchCode,
    "Disbursal Amount": item.disbursalAmount,
    "Disbursal Date": parseDateMDY(item.disbursalDate),
    "Total Collateral Value": item.totalCollateralValue,
    "Type": `${removeUnderscores(item.applicationType)} / ${removeUnderscores(item.applicationSubType)}`
  }));

  const worksheet = XLSX.utils.json_to_sheet(excelData);
  const workbook = XLSX.utils.book_new();

  XLSX.utils.book_append_sheet(workbook, worksheet, "Completed Data");

  XLSX.writeFile(workbook, "Completed_Data.xlsx");
};

  return (
    <Grid container>
      <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          label="Completed Details"
          onSearchChange={onSearchChange}
          searchLabel="Search For Details"
          search
          searchCriteria
          handleFromDateChange={handleFromDateChange}
          fromDate={fromDate}
          handleToDateChange={handleToDateChange}
          toDate={toDate}
        />
      </Grid>
      {particularDesignationAccess?.includes(userDetails?.designation) && <Grid item xs={12} sm={12} md={12}>
        <SubHeader
          button1={ "Download" }
          button1click={button1Click}
          tab="Completed"
        />
      </Grid>
      }
      <Grid item xs={12} sm={12} md={12}>
        <ColumnGroupingTable
          columns={visibleDeliverables}
          rows={selectedTableData}
          onClickUpdateData={onClickUpdateData}
          flag="completed"
        />
      </Grid>
      <StageHistoryModal
        open={stageHistoryModal}
        onClose={() => {
          setStageHistoryModal(false);
          setSelectedLeadId(null);
        }}
        leadId={selectedLeadId}
        authToken={authToken}
      />
      {toast && (
        <ToastModal
          toastMessage={toastMessage}
          toastMessageType={toastMessageType}
          toastUpdate={toastUpdate}
        />
      )}
      {(callInProgress || applicantDataLoading) && <CircularProgresss callInProgress />}
    </Grid>
  );
};

Completed.propTypes = {
  classes: PropTypes.object,
  setNext: PropTypes.func,
  setBack: PropTypes.func,
};

export default Completed;
